import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';

const QuestionnaireNextButton = ({ onClick, children, ...props }) => {
  return (
    <Button variant="contained" color="primary" onClick={onClick} {...props}>
      {children}
    </Button>
  );
};

QuestionnaireNextButton.defaultProps = {
  onClick: PropTypes.func,
};

QuestionnaireNextButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
};

export default QuestionnaireNextButton;
